'use strict';

intellidealerAppCoreModule.constant('PartsTopLevelTabsService', [
    {title:'mydealer.ui.shop_for_parts.breadcrumb', state:'navigation.parts.shopForParts'},
    {title:'mydealer.ui.my_shopping_lists.breadcrumb', state:'navigation.parts.myShoppingLists'},
    {title:'mydealer.ui.my_orders.breadcrumb', state:'navigation.parts.previousOrders'},
    {title:'mydealer.ui.my_parts_purchases.breadcrumb', state:'navigation.parts.orderHistory'}
  ]);